module.exports = __webpack_public_path__ + "img/Ok9M0M1MmhM.198ae259.jpg";